type ReportHandler = (metric: any) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals')
      .then((mod: any) => {
        try {
          const getCLS = mod.getCLS || mod.onCLS;
          const getFID = mod.getFID || mod.onFID;
          const getFCP = mod.getFCP || mod.onFCP;
          const getLCP = mod.getLCP || mod.onLCP;
          const getTTFB = mod.getTTFB || mod.onTTFB;
          const getINP = mod.getINP || mod.onINP; // optional in older versions

          if (getCLS) getCLS(onPerfEntry);
          if (getFID) getFID(onPerfEntry);
          if (getFCP) getFCP(onPerfEntry);
          if (getLCP) getLCP(onPerfEntry);
          if (getINP) getINP(onPerfEntry);
          if (getTTFB) getTTFB(onPerfEntry);
        } catch {}
      })
      .catch(() => {});
  }
};

export default reportWebVitals;
